/**
 * The catch-all route.
 *
 * Reachable two ways, and they mean different things: a typo, or a link to a
 * screen this build does not have. Neither is a server error, so it does not
 * pretend to be one.
 */
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ExploreOffIcon from '@mui/icons-material/ExploreOff';
import Button from '@mui/material/Button';
import { EmptyState } from '../components/EmptyState';

export default function NotFoundPage() {
  const { t } = useTranslation('system');

  return (
    <EmptyState
      icon={<ExploreOffIcon fontSize="inherit" />}
      title={t('notFound.title')}
      description={t('notFound.description')}
      action={
        <Button component={RouterLink} to="/" variant="contained">
          {t('notFound.back')}
        </Button>
      }
    />
  );
}
